export type SettingsKey =
  | 'Preferences'
  | 'Create User'
  | 'Invitations'
  | 'Contacts'
  | 'Users'
  | 'Profile'
  | 'Roles'
  | 'Ekco Users'
  | 'Products'
  | 'Sources'
  | 'Login Policy'
  | 'Demo Customers'
  | '';
export const settingsKey = Symbol() as InjectionKey<globalThis.Ref<SettingsKey>>;
